<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="标题">
              <a-input placeholder="请输入" v-model="queryParam.headline"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() =>{ queryParam = {} }" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="create" icon="plus" type="primary" v-action="'notice:noticeView:add'">新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'notice:noticeView:show'">
            <a @click="show(record)">详情</a>
          </span>
          <span v-if="$auth('notice:noticeView:edit') ||record.createBy === userInfo.userId">
            <a-divider type="vertical" />
            <a @click="edit(record)">修改</a>
            <a-divider type="vertical" />
          </span>
          <span v-if="$auth('notice:noticeView:del') ||record.createBy === userInfo.userId">
            <a-popconfirm title="是否删除" @confirm="deleteItem(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </div>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/notice/notice'
import { Ellipsis } from '@/components'
import { mapState } from 'vuex'
import { enterEvent } from '@/utils/util'
export default {
  name: 'NoticeView',
  mixins: [TableMixin],
  components: {
    Ellipsis
  },
  data () {
    return {
      description: '系统通知管理与交流',
      showable: false,
      clearDate: undefined,
      queryParam: {
        headline: null
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '标题',
          dataIndex: 'headline',
          customRender: (text, record) => {
            return (
              <a href="javascript:;" onClick={() => this.show(record)}>
                {text}
              </a>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.userId
    }),
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    create () {
      this.$router.push({ name: 'noticeAddOrUpdate', query: { id: null, type: 'add' } })
    },
    show (record) {
      const id = record.id
      this.$router.push({ name: 'noticeDetails', query: { id: id } })
    },
    edit (record) {
      const id = record.id
      const status = record.status
      this.$router.push({ name: 'noticeAddOrUpdate', query: { id: id, type: 'edit', status: status } })
    },
    deleteItem (record) {
      const id = record.id
      delObj(id).then(res => {
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  },
  activated () {
    this.queryPage()
  }
}
</script>

<style scoped>

</style>
